import React from 'react';

function GroupedPromoBox({ groupedPromo, selectedItems, onShowDetails, bgColor, borderColor, showFilteredOnly, viewFullCalendar, filteredPromoKeys }) {
    // Format dates for display
    const formatDate = (dateStr) => {
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric'
        });
    };

    // Get the items to display based on filter settings
    const getDisplayItems = (promo) => {
        if (showFilteredOnly && selectedItems && selectedItems.length > 0) {
            return promo.items.filter(item => selectedItems.includes(item.groupedName || item.item));
        }
        return promo.items;
    };

    // Calculate discount range for a promo instance (for Product Specific Promo and Sitewide Sale promos)
    const getDiscountRange = (promo, displayItems) => {
        const showDiscountTypes = ['Product Specific Promo', 'Sitewide Sale'];
        if (!showDiscountTypes.includes(promo.promoType)) {
            return null;
        }

        const discounts = displayItems
            .map(i => i.discount)
            .filter(d => d != null && d > 0);

        if (discounts.length === 0) return null;

        const uniqueDiscounts = [...new Set(discounts)].sort((a, b) => a - b);

        if (uniqueDiscounts.length === 1) {
            return `${(uniqueDiscounts[0] * 100).toFixed(0)}% off`;
        } else {
            return `${(uniqueDiscounts[0] * 100).toFixed(0)}-${(uniqueDiscounts[uniqueDiscounts.length - 1] * 100).toFixed(0)}% off`;
        }
    };

    const { name, instances } = groupedPromo;

    // Determine if this promo should be dimmed (View Full Calendar mode)
    const isDimmed = viewFullCalendar && filteredPromoKeys &&
        !instances.some(promo =>
            filteredPromoKeys.has(`${promo.name}|${promo.startDate}|${promo.endDate}`)
        );

    return (
        <div
            className={`promo-box grouped${isDimmed ? ' dimmed' : ''}`}
            style={{
                backgroundColor: bgColor,
                borderColor: borderColor
            }}
        >
            <div className="promo-name" style={{ color: '#212121' }}>
                {name}
            </div>

            {/* Show each date range with its items */}
            {instances.map((promo, idx) => {
                const displayItems = getDisplayItems(promo);
                const discountRange = getDiscountRange(promo, displayItems);

                return (
                    <div key={idx} className="grouped-instance">
                        <div className="promo-dates" style={{ color: '#424242' }}>
                            {formatDate(promo.startDate)} - {formatDate(promo.endDate)}
                        </div>

                        {/* Show item count (or All Webstore) and discount range on same line */}
                        <div className="promo-info-row">
                            {promo.allWebstore ? (
                                <span className="promo-info no-click">
                                    All Webstore Products
                                </span>
                            ) : (
                                <>
                                    <span
                                        className="promo-info"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onShowDetails(promo);
                                        }}
                                        title="Click to see items and discounts"
                                    >
                                        {displayItems.length} item{displayItems.length !== 1 ? 's' : ''}
                                    </span>
                                    {discountRange && (
                                        <span className="promo-discount">at {discountRange}</span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                );
            })}

            {/* Show promo details if any instance has them */}
            {instances[0].details && (
                <div className="promo-details">
                    {instances[0].details}
                </div>
            )}
        </div>
    );
}

export default GroupedPromoBox;
